module.exports = "/static/assets/709de1e4190e2fc8ef84100ad94157a4.png";